/* eslint no-param-reassign: ["error", { "props": false }]*/
export default {
  state: {
    showCart: false,
    showBorders: true,
    prevLook: '',
    nextLook: '',
    currentgender: '',
    cart: [],
    selectedColor: '',
  },
  mutations: {
    showCart(state) {
      state.showCart = true;
    },
    hideCart(state) {
      state.showCart = false;
    },
    hideBorders(state) {
      state.showBorders = false;
    },
    showBorders(state) {
      state.showBorders = true;
    },
    nextLabel(state, n) {
      state.nextLook = n;
    },
    prevLabel(state, n) {
      state.prevLook = n;
    },
    currentGender(state, gender) {
      state.currentgender = gender;
    },
    addToCart(state, { variant }) {
      state.cart.push(variant);
    },
    incrementQty(state, index) {
      state.cart[index].quantity += 1;
    },
    decrementQty(state, index) {
      if (state.cart[index].quantity >= 2) {
        state.cart[index].quantity -= 1;
      } else {
        state.cart.splice(index, 1);
      }
    },
    selectedColor(state, obj) {
      state.selectedColor = obj;
    },
  },
  getters: {
    cart: state => state.cart,
    cartSize: (state) => {
      let total = 0;
      let i = 0;
      for (i; i < state.cart.length; i += 1) {
        total += parseInt(state.cart[i].quantity, 10);
      }
      return total;
    },
    getItemIndex: state => id => state.cart.findIndex(cart => cart.id === id),
    cartExport: (state) => {
      const cartExp = [];
      state.cart.forEach((e, i) => {
        const item = {};
        item.id = e.id;
        item.quantity = `${e.quantity}`;
        cartExp[i] = item;
      });
      return cartExp;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store.js